var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 4.50001C17.1 3.50001 16.7 2.60001 16 1.90001C14.6 0.500006 12.2 0.500006 10.9 1.90001L9.89995 2.90001L0.399951 12.4C0.299951 12.5 0.199951 12.8 0.199951 13V17C0.199951 17.4 0.599951 17.8 0.999951 17.8H4.99995C5.19995 17.8 5.39995 17.7 5.59995 17.6L16.1 7.10001C16.8 6.40001 17.1 5.50001 17.1 4.50001ZM4.69995 16.2H1.79995V13.3L10.5 4.60001L13.4 7.50001L4.69995 16.2ZM14.9 5.90001L14.5 6.30001L11.6 3.40001L12 3.00001C12.8 2.20001 14.1 2.20001 14.9 3.00001C15.3 3.40001 15.5 3.90001 15.5 4.40001C15.5 5.00001 15.3 5.60001 14.9 5.90001ZM16.7999 17C16.7999 17.4 16.4 17.8 16 17.8H8.99995C8.59995 17.8 8.19995 17.4 8.19995 17C8.19995 16.6 8.59995 16.2 8.99995 16.2H16C16.4 16.2 16.7999 16.6 16.7999 17Z",
    fill: "#1F2938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.c6af3be8ba4e55191f058a152641ec55.svg";
export { ForwardRef as ReactComponent };